import * as React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

const UpdatedAtText = styled.p`
  @media (max-width: 1280px) {
    color: var(--primary-text-color);
  }
`;

const ScreenHeader = (props: { title: string; lastUpdate?: string }): JSX.Element => (
  <div>
    <h1>{props.title}</h1>
    {props.lastUpdate ? (
      <UpdatedAtText className="text-12 text-gray">
        <FormattedMessage id={'screenHeader.lastUpdate'} /> <b>{props.lastUpdate}</b>
      </UpdatedAtText>
    ) : null}
  </div>
);

export default ScreenHeader;
